module.exports = __webpack_public_path__ + "img/walking.848e35c3.svg";